import { BodyText, color, spacing, styled } from '@lessonup/ui-components';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { i18nextNamespaceAiTools } from './AiToolbox.utils';

export const Disclaimer = () => {
  const { t } = useTranslation(i18nextNamespaceAiTools);

  return (
    <StyledDisclaimer size="small">
      <Trans
        i18nKey="aiToolsDisclaimer"
        ns={i18nextNamespaceAiTools}
        components={[
          <a key="0" href={t('aiToolsDisclaimerLink')} target="_blank" rel="noopener noreferrer">
            {t('aiToolsDisclaimerLink')}
          </a>,
        ]}
      />
    </StyledDisclaimer>
  );
};

const StyledDisclaimer = styled(BodyText)`
  margin-top: ${spacing.size32};
  text-align: center;
  color: ${color.highContrast.disabled.text};

  @media print {
    display: none;
  }
`;
